import { api } from './client';
import type { LinkPreviewDto } from './types';

/** Метаданные (og:title/description/image) по ссылке — сервер ходит по URL сам, с SSRF-защитой. */
export function fetchLinkPreview(url: string): Promise<LinkPreviewDto> {
  return api<LinkPreviewDto>('/api/v1/link-preview', {
    method: 'POST',
    body: JSON.stringify({ url }),
  });
}

/**
 * Не удалось вытащить ничего осмысленного (сайт недоступен/без og-тегов/битый сертификат
 * и т.п.) — только голое имя хоста в siteName. Показывать почти пустую карточку/бар
 * бессмысленнее, чем просто оставить ссылку в тексте кликабельной.
 */
export function hasUsefulPreview(preview: LinkPreviewDto): boolean {
  return !!(preview.title || preview.description || preview.imageFileId);
}
